import { RouteInfo } from '../types/route';

export const ROUTES: RouteInfo[] = [
  { city: 'Bogotá', duration: '4 horas', description: 'En carro · Ruta Girardot – Espinal – Ibagué' },
  { city: 'Medellín', duration: '8 horas', description: 'En carro · Autopista Medellín–Bogotá' },
  { city: 'Ibagué', duration: '30 minutos', description: 'Bus directo disponible · Vía Payandé' },
  { city: 'Eje Cafetero', duration: '~6–7 horas', description: 'En carro · Por la Línea' },
];
